import { FC } from "react";

import { Divider, Grid, Skeleton } from "@mui/material";
import {
  TypographyH5,
  TypographyH6,
} from "@shared-ui-components/CustomTypography";

import {
  ErrorState,
  formatNumberWithComma,
  formatNumberWithCommaAndDollar,
  formatWithPercentage,
} from "@src/constants";
import { TOTAL_SALES_VIEW } from "./helper";
import { CustomTitle, TotalSalesValueWrapper } from "./style";

const TotalSalesData: FC<TotalSalesDataPropsType> = ({
  mapData,
  activeTab,
  loading,
}) => {
  const getSalesValue = (
    value: string | number | null | undefined,
    formatPercentage?: boolean,
    formatWithDollar?: boolean
  ) => {
    if (loading) return <Skeleton width="70%" />;
    if (value === null || value === undefined) return <ErrorState />;
    if (formatWithDollar)
      return (
        <TypographyH5>{formatNumberWithCommaAndDollar(value)}</TypographyH5>
      );
    if (formatPercentage)
      return <TypographyH5>{formatWithPercentage(value)}</TypographyH5>;
    return <TypographyH5>{formatNumberWithComma(value)}</TypographyH5>;
  };

  return (
    <>
      <Divider style={{ width: "100%", margin: "12px 0px", color: "red" }} />
      <Grid gap={0.6} alignItems="flex-end" container>
        {mapData?.map((i: RevenueDataType) => {
          const showColorTarget =
            i?.isTarget && activeTab === TOTAL_SALES_VIEW.REAL_TIME;
          return (
            <Grid key={i?.title} xs={3.8} md={3.8} item>
              {i?.isCurrent || showColorTarget ? (
                <CustomTitle isCurrent={i?.title === "current"}>
                  <TypographyH6 className="customTitle">
                    {i?.title}
                  </TypographyH6>
                </CustomTitle>
              ) : (
                <TypographyH6 className="title">{i?.title}</TypographyH6>
              )}
              <TotalSalesValueWrapper>
                {getSalesValue(
                  i?.value,
                  i?.formatPercentage,
                  i?.formatWithDollar
                )}
              </TotalSalesValueWrapper>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default TotalSalesData;
